import { setOrderProcessName } from "features/common/layouts/cartSlice";
import { resetError } from "features/common/products/productsSlice";
// import OrderStep from 'layouts/OrderStep'
import BubbleChat from "components/BubbleChat";
import CountdownBanner from "components/CountdownBanner";
import ErrorBoundary from "components/ErrorBoundary";
import ModalConfirmationCancel from "components/ModalConfirmationCancel";
import ModalRandomBuy from "components/PopupRandomBuy";
import { notifyError } from "components/ToastMessage";
import { useGoogleAnalyticsTracking } from "helpers/utils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Breadcrumbs from './Breadcrumbs';
import CheckoutTable from "./CheckoutTable";
import Navbar from "./Navbar";
import ProgressBar from "./ProgressBar";
// import PromoBackdrop from "components/PromoBackdrop";

const MainLayouts = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error } = useSelector((state) => state.products);
  const { orderProcessName, productsList } = useSelector((state) => state.cart);
  const cartHasItem = productsList.length !== 0;
  const [modalConfirmation, setModalConfirmation] = useState(false);

  // Track Google Analytics parameters from URL - Added here so it works on all pages
  //console.log('🟡 [MainLayouts] ===== MainLayouts Component Rendered =====');
  //console.log('🟡 [MainLayouts] About to call useGoogleAnalyticsTracking()...');
  useGoogleAnalyticsTracking();
  //console.log('🟡 [MainLayouts] useGoogleAnalyticsTracking() called');

  useEffect(() => {
    let isMounted = true;
    if (error.status && isMounted) {
      notifyError(error.msg);
      dispatch(resetError());
      navigate("/");
    }

    return () => {
      isMounted = false;
    };
  }, [error, dispatch, navigate]);

  const cancelOrderHandler = (e) => {
    setModalConfirmation(true);
  };

  const handlerCloseModal = () => {
    setModalConfirmation(false);
  };

  useEffect(() => {
    if (location.pathname === "/orderdomain") {
      const hasReseller = productsList.some(item => item.type === "reselleraccount");
      const hasHosting = productsList.some(item => item.type === "hostingaccount");
      if (hasReseller) {
        dispatch(setOrderProcessName("others"));
      } else if (hasHosting) {
        dispatch(setOrderProcessName("hosting"));
      } else {
        dispatch(setOrderProcessName("domain"));
      }
    }
    switch (location.pathname) {
      case "/orderhosting":
        dispatch(setOrderProcessName("hosting"));
        break;
      case "/migrasihosting":
        dispatch(setOrderProcessName("migrasiHosting"));
        break;
      case "/orderdomain":
        // dispatch(setOrderProcessName("domain"));
        break;
      case "/orderemailsuite":
        dispatch(setOrderProcessName("emailsuite"));
        break;
      case "/ordervps":
        dispatch(setOrderProcessName("vps"));
        break;
      case "/orderserver":
        dispatch(setOrderProcessName("server"));
        break;
      case "/ordersignature":
        dispatch(setOrderProcessName("digitalSignature"));
        break;
      case "/orderdomainbackorder":
        dispatch(setOrderProcessName("domainBackorder"));
        break;
      case "/orderdiegovpn":
        dispatch(setOrderProcessName("diegoVpn"));
        break;
      case "/orderssl":
        dispatch(setOrderProcessName("ssl"));
        break;
      case "/orderproduct":
        dispatch(setOrderProcessName("others"));
        break;
      case "/upgrade":
        dispatch(setOrderProcessName("upgrade"));
        break;
      case "/renew":
        dispatch(setOrderProcessName("renew"));
        break;
      case "/addon":
        dispatch(setOrderProcessName("addon"));
        break;
      case "/paymentmethod":
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        if (orderProcessName) {
          dispatch(setOrderProcessName(orderProcessName));
        }
        break;
      case "/ordersummary":
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        // Hapus logic redirect yang menyebabkan kembali ke halaman order awal
        // Logic ini tidak diperlukan karena orderProcessName bisa kosong untuk produk "other"
        break;
      default:
        if (process.env.NODE_ENV === "production") {
          window.location.href = "https://www.qwords.com";
        }
        if (process.env.NODE_ENV === "development") {
          window.location.href = "https://stagingv8.portal.qwords.com";
        }
        break;
    }
  }, [location, dispatch, navigate, orderProcessName, productsList]);

  return (
    <>
      <Navbar />
      <ProgressBar />
      <div id="portalCheckout">
        <div className="section-init pt-3">
          <div
            className="container-fluid container-xxl"
            style={{ minHeight: "79vh" }}
          >
            {location.pathname !== '/' && (
              <div className="row justify-content-center">
                <div className="col-12 col-md-12 col-lg-12 col-xl-11">
                  {productsList.length > 0 && <CountdownBanner />}
                  <Breadcrumbs />
                </div>
              </div>
            )}

            {/* {location.pathname !== '/' &&
							location.pathname !== '/paymentmethod' &&
							location.pathname !== '/ordersummary' && (
								<div className="row justify-content-center">
									<div className="col-12 col-md-12 col-lg-12 col-xl-8">
										<OrderStep />
									</div>
								</div>
							)}

						{location.pathname === '/paymentmethod' && (
							<div className="row justify-content-center d-none d-lg-flex">
								<div className="col-12 col-md-12 col-lg-12 col-xl-8">
									<OrderStep />
								</div>
							</div>
						)}

						{location.pathname === '/ordersummary' && (
							<div className="row justify-content-center d-none d-lg-flex">
								<div className="col-12 col-md-12 col-lg-12 col-xl-8">
									<OrderStep />
								</div>
							</div>
						)} */}

            <div className="row justify-content-center">
              <div
                className="col-12 col-md-12 col-lg-7 col-xl-7 position-relative mb-lg-0 mb-3"
                id="leftSide"
              >
                <ErrorBoundary>
                  {props.children}
                </ErrorBoundary>
              </div>
              <div
                className={`col-12 col-md-12 ${props.summary ? "col-lg-7 col-xl-7 mt-3" : "col-lg-5 col-xl-4"
                  } checkout-sticky sticky-top`}
                id="rightSide"
                style={{ zIndex: "1000" }}
              >
                <ErrorBoundary>
                  <CheckoutTable isSummaryPage={props.summary} />
                </ErrorBoundary>

                {cartHasItem && (
                  <div className="text-center mt-2">
                    <button
                      onClick={cancelOrderHandler}
                      className="btn btn-outline-secondary btn-sm hover-shadow rounded-5 px-4 w-100"
                    >
                      <p className="mb-0 fw-bold">Lihat Produk Lain</p>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalConfirmationCancel
        show={modalConfirmation}
        onHide={handlerCloseModal}
      />
      <ModalRandomBuy />
      {/* <PromoBackdrop /> */}
      <BubbleChat productsList={productsList} />
      <ToastContainer limit={3} theme="dark" />
    </>
  );
};

export default MainLayouts;
